export const routes = {
  HOME: "/",
  OVERVIEW: "/overview",
  COLLECTION: "/collection",
  OPERATORVIEW: "/collection-view",
  AGENCYVIEW: "/agency-view",
  SETTLEMENT: "/settlement",
  DISTANCE_REPORT_VIEW: "/report/distance/distance-report-details",
  MOBILE_TICKET_DETAILS: "/report/mobile-ticket/mobile-ticket-details",
  REPORT: "/report",
  DISTANCE_REPORT: "/manual/distance",
  MOBILE_TICKET_REPORT: "/report/mobile-ticket",
  MOBILE_TICKET_RESIDUAL_SETTLEMENT: "/report/mobile-ticket/residual-settlement",
  PASS_REPORT: "/report/pass",
  PASS_DETAILS: "/report/pass/pass-details",
  PASS_REVENUE_DISTRIBUTION: "/report/pass/revenue-distribution",
  PASS_SETTLEMENT_REPORT: "/report/pass-settlement",
  PASS_SETTLEMENT_RESIDUAL_SETTLEMENT: "/report/pass-settlement/residual-settlement",
  CONTRACT: "/contract",
  CARDCOLLECTION: "/collection/card-collection",
  BUSDETAIL: "/collection/details",
  DATE_DETAIL_OPERATOR: "/settlement-view/date-details",
  DATEDETAIL: "/settlement/operator-settlement/date-details",
  OPERATOR_VEHICLE_DETAIL: "/collection-view/details",
  BALANCE_LOADED: "/collection-view/balance-loaded",
  DAY_WISE_BALANCE_LOADED: "/collection-view/details/balance-loaded",
  DAY_WISE_BALANCE_SPENT: "/collection-view/details/balance-spent",
  OPERATOR_SETTLEMENT_TAB: "/settlement-view",
  OPERATOR_CONTRACT_TAB: "/contract-view",
  BALANCE_SPENT: "/collection-view/balance-spent",
  VEHICLECONTRACT: "/contract/vehicle",
  OPERATORSETTLEMENT: "/settlement/operator-settlement",
  PREVIOUS_SETTLEMENT_DETAIL: "/settlement/operator-settlement/details",
  PREVIOUS_SETTLEMENT_DETAILS: "/settlement/operator-settlement/previous-settlement-details",
  REPORTS_MODULE: "/report/reports",
  OPERATOR_WISE_REPORT: "/manual/operator-wise",
  BULK_EDIT_GROSS_CONTRIBUTION: "/manual/bulk-edit-gross-contribution",
  EXPENSES: "/manual/expenses",
  ADMIN_CITY_CONFIG: "/system-config/admin-city-config",
  PASS_REVENUE: "/manual/pass-revenue",
  ADMIN_CONFIG: "/system-config/agency-config",
  OPERATOR_CONFIG: "/system-config/operator-config",
  CITY_CONFIG: "/system-config/city-config",
};

export const extraRoutes = {
  LOGIN: "/login",
};
